import { type ReactNode } from 'react'
import { useUser } from '@/hooks/use-user'
import { NotSiteAdmin } from './NotSiteAdmin'

/**
 * Route guard for /admin/* pages. level='admin' requires isAdmin;
 * level='staff' also admits community managers (isSuperUser) — the two-level
 * gate from the Phase-4 admin-announcements spec (D2).
 */
export function AdminRoute({ level, children }: { level: 'admin' | 'staff'; children: ReactNode }) {
  const { user, isLoading } = useUser()

  if (isLoading) {
    return <div className="text-center py-8 text-gray-400">Loading...</div>
  }

  const allowed =
    level === 'admin' ? !!user?.isAdmin : !!(user?.isAdmin || user?.isSuperUser)

  if (!allowed) return <NotSiteAdmin />
  return <>{children}</>
}
